import t from"styled-components";import{theme as o}from"../../../theme.js";const e=t.div`
  a {
    color: ${o.colors.primary[500]};
  }
  position: relative;
  .placeholder {
    font-size: 16px;
    color: ${o.colors.gray[500]};
    position: absolute;
    top: 0;
    left: 0;
  }
  .DraftEditor-root {
    min-height: 150px;
    max-height: 250px;
    overflow-y: auto;
    .DraftEditor-editorContainer,
    .public-DraftEditor-content {
      min-height: 150px;
      max-height: 250px;
    }
  }
  @media screen and (max-width: ${o.breakpoints.md}) {
    width: 100%;
    .DraftEditor-root {
      overflow-y: auto;
      max-height: unset;
    }
  }
`,i=t.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media screen and (max-width: ${o.breakpoints.md}) {
    position: fixed;
    left: 0;
    top: 56px;
    z-index: 20;
    width: 100%;
    padding: 0 ${o.spacing*4}px;
    height: 56px;
    box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    background-color: ${o.colors.shades[0]};
  }
`;export{i as FlexWrapper,e as Wrapper};
